import {RemoteGetHealthSpecialtiesLocalities} from 'data/usecases/private/booking-flow/health';
import {GetHealthSpecialtiesLocalities} from 'domain/usecases/private/booking-flow/health';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetHealthSpecialtiesLocalities = (): GetHealthSpecialtiesLocalities =>
	new RemoteGetHealthSpecialtiesLocalities(
		makeBFFApiUrl(BookingFlowEndPoints.healthSpecialtiesLocalities),
		makeAuthorizeHttpClientDecorator(),
	);
